import React, { useEffect, useState } from "react";

import { NavLink, Outlet, useNavigate } from "react-router-dom";

import { FaFileInvoiceDollar } from "react-icons/fa";

import { onAuthStateChanged, signOut } from "firebase/auth";

import {
  FaHome,
  FaProjectDiagram,
  FaImages,
  FaBlog,
  FaCog,
  FaSignOutAlt,
} from "react-icons/fa";

import { auth } from "../../firebase/firebase";

// ==========================================
// NOTIFICATION COMPONENT
// ==========================================

import NotificationBell from "../components/NotificationBell";

import "./AdminLayout.css";

const AdminLayout = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);

  // ==========================================
  // AUTHENTICATION
  // ==========================================

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);

        navigate("/admin/login", {
          replace: true,
        });
      }

      setCheckingAuth(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  // ==========================================
  // LOGOUT
  // ==========================================

  const handleLogout = async () => {
    try {
      await signOut(auth);

      navigate("/admin/login", {
        replace: true,
      });
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  // ==========================================
  // AUTH LOADING
  // ==========================================

  if (checkingAuth) {
    return (
      <div className="admin-auth-loading">
        <div className="admin-auth-spinner"></div>

        <p>Checking authentication...</p>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  // ==========================================
  // ADMIN LAYOUT
  // ==========================================

  return (
    <div className="admin-layout">
      {/* ======================================
          SIDEBAR
      ====================================== */}

      <aside className="admin-sidebar">
        {/* LOGO */}

        <div className="admin-logo">
          <h2>Quality Sports</h2>

          <span>ADMIN PANEL</span>
        </div>

        {/* NAVIGATION */}

        <nav className="admin-nav">
          {/* DASHBOARD */}

          <NavLink to="/admin/dashboard">
            <FaHome />

            <span>Dashboard</span>
          </NavLink>

          {/* PROJECTS */}

          <NavLink to="/admin/projects">
            <FaProjectDiagram />

            <span>Projects</span>
          </NavLink>

          {/* SERVICES */}

          {/* <NavLink to="/admin/services">
            <FaTools />

            <span>Services</span>
          </NavLink> */}

          {/* GALLERY */}

          <NavLink to="/admin/gallery">
            <FaImages />

            <span>Gallery</span>
          </NavLink>

          {/* BLOGS */}

          <NavLink to="/admin/blogs">
            <FaBlog />

            <span>Blogs</span>
          </NavLink>

          {/* QUOTE REQUESTS */}

          <NavLink to="/admin/quote-requests" className="admin-sidebar-link">
            <FaFileInvoiceDollar />

            <span>Quote Requests</span>
          </NavLink>

          {/* SETTINGS */}

          <NavLink to="/admin/settings">
            <FaCog />

            <span>Settings</span>
          </NavLink>
        </nav>

        {/* ==================================
            LOGOUT
        ================================== */}

        <div className="admin-sidebar-bottom">
          <button className="admin-logout-button" onClick={handleLogout}>
            <FaSignOutAlt />

            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* ======================================
          MAIN CONTENT
      ====================================== */}

      <main className="admin-main">
        {/* ====================================
            HEADER
        ==================================== */}

        <header className="admin-header">
          {/* HEADER TITLE */}

          <div className="admin-header-title">
            <h1>Admin Dashboard</h1>
          </div>

          {/* ==================================
              HEADER RIGHT SIDE
          ================================== */}

          <div className="admin-header-right">
            {/* =================================
                NOTIFICATION BELL
            ================================= */}

            <NotificationBell />

            {/* =================================
                ADMIN USER
            ================================= */}

            <div className="admin-user">
              <div className="admin-user-avatar">
                {user.email ? user.email.charAt(0).toUpperCase() : "A"}
              </div>

              <div className="admin-user-info">
                <strong>Admin</strong>

                <span>{user.email}</span>
              </div>
            </div>
          </div>
        </header>

        {/* ======================================
            PAGE CONTENT
        ====================================== */}

        <section className="admin-content">
          <Outlet />
        </section>
      </main>
    </div>
  );
};

export default AdminLayout;
